import React from "react";
import axios from "axios";

export const getAVisaApplicationApi = async (token,id) => {
  try {
    let url = `https://visapro-api.tcore.online/api/v1/applications/${id}`;

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const userInfo = {
      data: response.data,

    };
    return userInfo;
  } catch (error) {

    const userInfo = {
      error: error,
    };
    return userInfo;
  }
};
